import { PayloadAction } from '@reduxjs/toolkit';
import { HttpServiceResponse } from '@/services/HttpService/types';
import { GoogleAddressValidationRequest, GoogleAddressValidationResponse } from './types';
import { call, put, takeLatest } from 'redux-saga/effects';
import HttpService from '@/services/HttpService/HttpService';
import { defineIsAddressValid } from './utils/defineIsAddressValid';
import { GoogleApiBaseUrls } from '../../enums/GoogleApiBaseUrls';
import {
  triggerAddressValidation,
  updateAddressValidationResult,
  updateIsAddressValid,
} from '../store/googleAddressValidationApiSlice';

const apiKey = import.meta.env.VITE_GOOGLE_API_KEY;

function* googleAddressValidationSaga({ payload }: PayloadAction<GoogleAddressValidationRequest>) {
  try {
    const { data }: HttpServiceResponse<GoogleAddressValidationResponse> = yield call(
      HttpService.post,
      `${GoogleApiBaseUrls.ADDRESS_VALIDATION}:validateAddress?key=${apiKey}`,
      payload,
      {
        baseURL: '',
      },
    );
    yield put(updateAddressValidationResult(data));

    const isAddressValid = defineIsAddressValid(data);
    yield put(updateIsAddressValid(isAddressValid));
  } catch (error) {
    console.error(error);
  }
}

export function* googleAddressValidationApiWatcher() {
  yield takeLatest(triggerAddressValidation.type, googleAddressValidationSaga);
}
